module.exports = __webpack_public_path__ + "static/media/essendon.ad290694.svg";